import React, { Component } from 'react';
import { ErrorPageTypes } from '../../../../types/index';
import { PERSEUS_ERROR_TYPES } from '../../../../utils/constants';
import tracker from '../../../../service/tracker';
import OopsPage from './OopsPage';

const errorMap = {
    [PERSEUS_ERROR_TYPES.OOPS_PAGE_ERROR] : OopsPage
};

class ErrorPage extends Component {

    componentDidMount() {
        tracker.error();
    }

    render() {
        const { errorContext } = this.props;
        const Error = errorMap[errorContext.type] || OopsPage;

        return (
            <div className="listings-perseus">
                <Error errorContext={errorContext}/>
            </div>
        );
    }
}

ErrorPage.propTypes = ErrorPageTypes;

export default ErrorPage;
